"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ = require("../..");
var _SourceVolumeControl = _interopRequireDefault(require("./SourceVolumeControl"));
var _Permissions = require("../../constants/Permissions");
var _Permission = _interopRequireDefault(require("../Permissions/Permission"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// permissions

var getViewPermissions = function getViewPermissions() {
  return [_Permissions.TOGGLE_MUTE];
};
var SourceMediaControl = function SourceMediaControl(_ref) {
  var sourceId = _ref.sourceId,
    type = _ref.type,
    onVolumeChanged = _ref.onVolumeChanged,
    source = _ref.source,
    live = _ref.live,
    isAudioSource = _ref.isAudioSource,
    user = _ref.user,
    viewPermissions = _ref.viewPermissions;
  var volumeControlProps = (0, _react.useMemo)(function () {
    return {
      type: type,
      live: live,
      sourceId: sourceId,
      isAudioSource: isAudioSource,
      muted: source.value.muted,
      volume: source.value.volume,
      onVolumeChanged: onVolumeChanged
    };
  }, [type, live, sourceId, isAudioSource, source.value.muted, source.value.volume, onVolumeChanged]);
  var displayComponent = (0, _react.useCallback)(function (enableFeature) {
    if (!enableFeature) {
      return null;
    }
    return /*#__PURE__*/_react["default"].createElement(_SourceVolumeControl["default"], (0, _extends2["default"])({
      enableFeature: enableFeature
    }, volumeControlProps));
  }, [volumeControlProps]);
  if ([_.CAMERA_PRESENTER, _.SCREEN_PRESENTER, _.IMAGE_FILE, _.MEDIA].includes(type)) return null;
  return /*#__PURE__*/_react["default"].createElement(_Permission["default"], {
    permissions: getViewPermissions(),
    protectedComponent: displayComponent,
    user: user,
    viewPermissions: viewPermissions
  });
};
SourceMediaControl.propTypes = {
  type: _propTypes["default"].string,
  onVolumeChanged: _propTypes["default"].func,
  sourceId: _propTypes["default"].string.isRequired,
  source: _propTypes["default"].object.isRequired,
  isAudioSource: _propTypes["default"].bool,
  volume: _propTypes["default"].number,
  live: _propTypes["default"].bool,
  user: _propTypes["default"].object,
  viewPermissions: _propTypes["default"].object
};
var _default = exports["default"] = SourceMediaControl;